"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.accountFields = exports.FIDMAN_EMAIL_MESSAGE = exports.FIDMAN_EMAIL_RULE = void 0;
const Yup = __importStar(require("yup"));
const MainSetupReact_1 = __importDefault(require("../React/MainSetupReact"));
/**
 * Reguły pól konta wspólne dla ekranu użytkowników i panelu „Personel i uprawnienia".
 * Jedno miejsce, bo oba okna zapisują konto tą samą trasą (PUT /v2/persons/:id/account)
 * i serwer odrzuca te same przypadki - komunikat ma być identyczny w obu oknach.
 */
/** GLO-P1: jedna reguła, dwa pola - patrz komentarz przy systemEmail. */
exports.FIDMAN_EMAIL_RULE = "fidman-wymaga-emaila-systemowego";
exports.FIDMAN_EMAIL_MESSAGE = "Użytkownik FIDmana musi mieć e-mail systemowy";
exports.accountFields = {
    systemEmail: Yup.string()
        .default("")
        .max(50, "Email może mieć maksymalnie 50 znaków")
        // Ta sama reguła co przy fidmanEnabled, celowo w dwóch miejscach: react-hook-form
        // w trybie onChange pokazuje błąd tylko przy polu, które użytkownik właśnie zmienił.
        // Gdyby reguła wisiała wyłącznie przy checkboksie, wyczyszczenie e-maila blokowałoby
        // zapis bez słowa wyjaśnienia - przycisk "Zatwierdź" po prostu przestałby działać.
        .test(exports.FIDMAN_EMAIL_RULE, exports.FIDMAN_EMAIL_MESSAGE, function (value) {
        if (!this.parent?.fidmanEnabled)
            return true;
        return String(value ?? "").trim().length > 0;
    }),
    // Konto w FIDmanie powstaje z e-maila systemowego - to on jest tożsamością logowania
    // Google. Serwer też odrzuca taki zapis (400 z tym samym komunikatem), ale problem ma
    // być widoczny tam, gdzie powstaje, czyli przy polu w formularzu.
    fidmanEnabled: Yup.boolean().test(exports.FIDMAN_EMAIL_RULE, exports.FIDMAN_EMAIL_MESSAGE, function (value) {
        if (!value)
            return true;
        return String(this.parent?.systemEmail ?? "").trim().length > 0;
    }),
    // Rola zakresowa bez przypisanego projektu nie zobaczy niczego (backend traktuje
    // pustą listę jako brak dostępu), więc konto bez projektów jest bezużyteczne.
    _projectAssignments: Yup.array().when("systemRoleId", {
        is: (systemRoleId) => MainSetupReact_1.default.isProjectScopedRoleId(systemRoleId),
        then: (schema) => schema.min(1, "Wskaż co najmniej jeden projekt"),
        otherwise: (schema) => schema.notRequired(),
    }),
};
